import { render, staticRenderFns } from "./ShopAllocationManagement.vue?vue&type=template&id=7a530978&scoped=true"
import script from "./ShopAllocationManagement.vue?vue&type=script&lang=js"
export * from "./ShopAllocationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a530978",
  null
  
)

export default component.exports